import { webKnots } from '../../../../common/back/lace/webKnots'
import { allowLace } from '../lace/allowCenterOfCrossWeb'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const w1Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  // 中央の切り込み
  ctx.moveTo(521, 313) // 左下
  ctx.quadraticCurveTo(560, 245, 620, 190) // 右上
  ctx.quadraticCurveTo(572, 262, 524, 314) // 左下
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側_外
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 外側_内
  ctx.moveTo(555, 88) // 左上
  ctx.quadraticCurveTo(512, 166, 491, 251) // 左下
  ctx.quadraticCurveTo(512, 322, 580, 352) // 右下
  ctx.quadraticCurveTo(628, 323, 690, 271) //
  // 中央切り込みの周り
  ctx.moveTo(519, 307) // 左下＿左
  ctx.quadraticCurveTo(553, 240, 619, 184) // 左上
  ctx.quadraticCurveTo(625, 192, 624, 192) // 右上
  ctx.quadraticCurveTo(579, 268, 527, 317) // 左下＿右

  // デザイン左＿外
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(583, 107, 583, 107) // 右上
  ctx.quadraticCurveTo(545, 188, 512, 223) // 右下＿左
  ctx.quadraticCurveTo(502, 278, 502, 278) // 下
  ctx.quadraticCurveTo(525, 229, 525, 229) // 右下＿右
  ctx.quadraticCurveTo(553, 199, 593, 115) // 中央＿左上
  ctx.quadraticCurveTo(638, 153, 663, 207) // 中央＿右上
  ctx.quadraticCurveTo(607, 264, 597, 297) // 右下＿左
  ctx.quadraticCurveTo(552, 338, 552, 338) // 下
  ctx.quadraticCurveTo(605, 308, 605, 308) // 右下＿右
  ctx.quadraticCurveTo(615, 275, 667, 218) // 右上＿左
  ctx.quadraticCurveTo(676, 235, 687, 271) // 右上＿右

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  allowLace(ctx, laceColor, -35, 35)
  allowLace(ctx, laceColor, -48, 50)
  allowLace(ctx, laceColor, -62, 70)
  allowLace(ctx, laceColor, -76, 88)
  allowLace(ctx, laceColor, -90, 105)
  allowLace(ctx, laceColor, -102, 120)
  webKnots(ctx, laceColor, -90, 90, 1) //
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
